import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette }) =>
  createStyles({
    row: {
      width: '100%',
      position: 'relative',
      '& td': {
        backgroundColor: palette.background.default,
        borderBottom: '0px solid ' + palette.divider,
        padding: '1.2rem 0.5rem',
        //maxWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',

        '&:first-child': {
          width: '130px',
          minWidth: '130px',
          color: 'var(--text-title)',
          borderTopLeftRadius: 5,
          borderBottomLeftRadius: 5,
          paddingLeft: '2rem',
        },
        '&:nth-child(2), &:nth-child(3)': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
        '&:nth-child(2)': {
          width: '380px',
          minWidth: '380px',
        },
        '&:nth-child(3)': {
          width: '220px',
          minWidth: '220px',
        },
        '&:nth-child(4)': {
          '& .MuiTypography-subtitle2': {
            display: 'flex',
            alignItems: 'center',
            height: '2.4rem',
            padding: '0 1rem',
            backgroundColor: '#DEE5DA',
            borderRadius: '5px',
            fontSize: '1.1rem',
          },
        },
        '&:nth-child(5)': {
          width: '120px',
          minWidth: '120px',
        },
        '&:last-child': {
          borderTopRightRadius: 5,
          borderBottomRightRadius: 5,
          paddingRight: '1.6rem',
          width: '24px',
          minWidth: '24px',
        },
      },
    },
    blueLabel: {
      backgroundColor: '#55AFCB',
      zIndex: 1,
      position: 'relative',
    },
    greenLabel: {
      backgroundColor: '#A0C84B',
      zIndex: 1,
      position: 'relative',
    },
    orangeLabel: {
      backgroundColor: '#FAAF32',
      zIndex: 1,
      position: 'relative',
    },
    darkOrangeLabel: {
      backgroundColor: '#E67A32',
      zIndex: 1,
      position: 'relative',
    },
    redLabel: {
      backgroundColor: '#E64B32',
      zIndex: 1,
      position: 'relative',
    },
    disabled: { cursor: 'not-allowed' },

    statusCell: {
      '& > div': {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '0.8rem',
        height: '2.4rem',
        padding: '0.7rem 0.8rem',
        color: '#ffffff',
        fontSize: '1.2rem',
        borderRadius: '5px',
        '& > span': {
          display: 'flex',
          alignItems: 'center',
          '& svg': {
            width: '1.4rem',
            height: '1.6rem',
          },
        },
      },
    },

    tooltip: {
      backgroundColor: '#505356',
      color: '#FFFFFF',
      fontSize: '1.2rem',
      lineHeight: '1.5rem',
      padding: '0.7rem 2.5rem',
      border: 'none',
      borderRadius: 5,
      textAlign: 'center',
      maxWidth: '500px',
    },

    popper: {
      marginTop: '-10px',
    },
    link: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      textDecoration: 'none',
      color: 'inherit',
    },
  }),
)
